import { Controller } from "@hotwired/stimulus"

const COOKIE_NAME = "mc_analytics_consent"
const COOKIE_EXPIRY_DAYS = 365

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    const consent = this.readCookie()
    if (consent) {
      this.removeBanner()
    }
  }

  accept() {
    this.writeCookie("accepted")
    window.dispatchEvent(new CustomEvent("analytics:accepted"))
    this.removeBanner()
  }

  decline() {
    this.writeCookie("declined")
    this.removeBanner()
  }

  // -- private ---------------------------------------------------------------

  readCookie() {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`))
    return match ? match[1] : null
  }

  writeCookie(value) {
    const expires = new Date(Date.now() + COOKIE_EXPIRY_DAYS * 864e5).toUTCString()
    document.cookie = `${COOKIE_NAME}=${value}; path=/; expires=${expires}; SameSite=Lax`
  }

  removeBanner() {
    this.element.remove()
    document.body.classList.remove("has-consent-banner")
  }
}
